import { Link } from 'react-router-dom';
import type { BillRecord } from '@/lib/db/billsRepo';
import { useObjectUrl } from '@/hooks/useObjectUrl';

const STATUS_LABEL: Record<BillRecord['submissionState'], string> = {
  draft: 'Draft',
  ready: 'Ready to submit',
  marked_submitted: 'Submitted ✓ (self-reported)',
};

const STATUS_STYLE: Record<BillRecord['submissionState'], string> = {
  draft: 'text-slate-500',
  ready: 'text-amber-700',
  marked_submitted: 'text-emerald-700',
};

export default function BillListItem({ bill }: { bill: BillRecord }) {
  const thumbUrl = useObjectUrl(bill.imageThumbnail);
  const { billNumber, amount, billDateBs } = bill.billData;

  return (
    <Link
      to={`/history/${bill.id}`}
      className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white p-3 shadow-sm active:bg-slate-50"
    >
      <div className="h-14 w-14 shrink-0 overflow-hidden rounded-lg bg-slate-100">
        {thumbUrl && <img src={thumbUrl} alt="" className="h-full w-full object-cover" />}
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate font-semibold text-slate-900">Bill #{billNumber.value ?? '—'}</p>
        <p className="text-sm text-slate-600">
          {amount.value !== null ? `Rs. ${amount.value.toFixed(2)}` : 'Amount unknown'}
          {billDateBs.value ? ` · ${billDateBs.value}` : ''}
        </p>
        <p className={`text-xs font-medium ${STATUS_STYLE[bill.submissionState]}`}>{STATUS_LABEL[bill.submissionState]}</p>
      </div>
    </Link>
  );
}
